"use client";

import { HmcSpinner } from "@adi-ctx/harmonic-core-components-react";
import { CMSHeader, Login, useAuth } from "@/components";
import type { TPropsWithChildren } from "@/types/component.types";
import type { ComponentType } from "react";
import { pathNames } from "@/lib/constants/pathNames.constants";
import { allowedUsers } from "@/lib/constants/cms.constants";
import { t } from "@/utils";

/**
 * Authenticate the user before rendering the BaseComponent
 * @param BaseComponent
 */
function withAuth(BaseComponent: ComponentType<any>) {
	function Auth(props: TPropsWithChildren) {
		const {
			isAuthenticated,
			isAuthenticatingInProgress,
			cognitoUserInfo: userInfo,
		} = useAuth();

		if (isAuthenticatingInProgress) {
			return (
				<div className="flex h-full w-full justify-center p-4 sm:py-10">
					<div className="hmc-body-s flex flex-col items-center gap-4">
						<HmcSpinner kind="secondary" size="md" />
						{t("auth.action-in-progress")}
					</div>
				</div>
			);
		}

		if (!isAuthenticated || !userInfo) {
			return (
				<>
					<CMSHeader />
					<main className="flex grow flex-col">
						<Login />
					</main>
				</>
			);
		}

		// Allow only the predefined users to enter the CMS
		if (!allowedUsers.includes(userInfo.email!)) {
			window.location.href = pathNames.home;
			return;
		}

		// If user is authenticated, return the BaseComponent
		return <BaseComponent {...props}>{props.children}</BaseComponent>;
	}

	return Auth;
}

export default withAuth;
